import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { colors } from 'styles/colors';
import { devices } from 'styles/devices';
import Headline from 'ui/Headline';
import Paragraph from 'ui/Paragraph';

const NavBox = ({ headline, description, imageSrc, path, link, alt }) => {
   const renderContent = () => (
      <>
         <StyledHeadline size="M">{headline}</StyledHeadline>
         <StyledParagraph size="XL">{description}</StyledParagraph>
         <ImageWrapper>
            <Image src={imageSrc} alt={alt} />
         </ImageWrapper>
      </>
   );

   return (
      <Wrapper>
         {path ? (
            <StyledLink to={path}>{renderContent()}</StyledLink>
         ) : (
            <ExternalLink href={link} target="_blank">
               {renderContent()}
            </ExternalLink>
         )}
      </Wrapper>
   );
};

const StyledHeadline = styled(Headline)`
   margin-bottom: 10px;
   font-size: 1rem;
   min-height: auto;
   ${devices.tablet} {
      min-height: 40px;
   }
`;

const StyledParagraph = styled(Paragraph)`
   min-height: auto;
   ${devices.tablet} {
      min-height: 100px;
   }
`;

const Wrapper = styled.div`
   width: 100%;
   background: ${colors.white};
   transition: transform 0.15s ease-in-out;

   &:hover {
      transform: scale(0.995);
   }
`;

const link = () => css`
   display: block;
   padding: 30px;
   margin: 0;
   text-decoration: none;
   color: #000;
   cursor: pointer;

   &:hover {
      text-decoration: none;
      color: ${colors.black};
   }

   ${devices.desktop} {
      padding: 40px;
   }

   ${devices.desktopFHD} {
      padding: 60px;
   }
`;

const StyledLink = styled(Link)`
   ${link}
`;

const ExternalLink = styled.a`
   ${link}
`;

const ImageWrapper = styled.div`
   width: 100%;

   ${devices.desktop} {
      width: 80%;
      margin: 0 auto;
   }

   ${devices.desktopHD} {
      width: 100%;
      margin: 30px 0 0;
   }
`;

const Image = styled.img`
   display: block;
   width: 100%;
`;

NavBox.propTypes = {
   headline: PropTypes.string.isRequired,
   description: PropTypes.string.isRequired,
   imageSrc: PropTypes.string.isRequired,
   alt: PropTypes.string.isRequired
};

export default NavBox;
